/**
 * Available distance range options in miles for the location filter.
 * These values match the radius options in ws-locations-search.
 * @constant {number[]}
 */
export const MILE_RANGES = [10, 25, 50, 100, 200, 500];

/**
 * Default radius in miles when no preference is stored.
 * @constant {number}
 */
export const DEFAULT_RADIUS = 50;

/**
 * SessionStorage key for persisting user's radius preference.
 * @constant {string}
 */
export const SESSION_STORAGE_KEY = 'locationSearchRange';
